import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, Trophy } from 'lucide-react';
export function SolutionSection() {
  const pillars = [{
    icon: <Target className="h-10 w-10 text-white" data-id="element-109" />,
    title: 'Re-cableado de Dopamina',
    description: 'Ejercicios diarios de 10 minutos que reprograman el sistema de recompensa del cerebro — sin quitar dispositivos',
    color: 'bg-[#2B7FD4]'
  }, {
    icon: <Zap className="h-10 w-10 text-white" data-id="element-110" />,
    title: 'Blindaje Mental',
    description: 'Protocolos para mantener el rendimiento cognitivo durante horas de estudio, como un operador de élite',
    color: 'bg-[#F97316]'
  }, {
    icon: <Trophy className="h-10 w-10 text-white" data-id="element-111" />,
    title: 'De la Apatía a la Acción',
    description: 'El mapa de 21 días que convierte la energía dispersa en metas concretas — lo que los colegios no te enseñan',
    color: 'bg-[#1B3A6B]'
  }];
  return <section id="how-it-works" className="py-20 bg-[#EFF6FF] relative" data-id="element-112">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent" data-id="element-113" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-115">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-[#1B3A6B] mb-6 uppercase" data-id="element-116">
            No le quites el teléfono. <br data-id="element-117" />
            <span className="text-[#2B7FD4]" data-id="element-118">Re-cablea su dopamina.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-119">
            Los castigos fallan porque atacan el síntoma. El Re-cableado de
            Dopamina ataca la raíz. Enfoque de Acero usa la misma psicología de
            rendimiento que usan los atletas de élite adaptada para jóvenes de 9
            a 12 años criados en el mundo digital.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-120">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-100 flex flex-col h-full" data-id="element-121">
              <div className={`${pillar.color} p-6 flex justify-center items-center`} data-id="element-122">
                {pillar.icon}
              </div>
              <div className="p-8 flex-1 flex flex-col" data-id="element-123">
                <h3 className="text-xl font-bold text-[#1B3A6B] mb-3 uppercase tracking-wide" data-id="element-124">
                  {pillar.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-125">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}